// extracted by css-extract-rspack-plugin
export default {"columnError":"src-wab-client-components-sidebar-tabs-DataBinding-DataPickerColumn-module__columnError-RNmK1M","columnErrorTitle":"src-wab-client-components-sidebar-tabs-DataBinding-DataPickerColumn-module__columnErrorTitle-j3NV8Y","columnErrorMessage":"src-wab-client-components-sidebar-tabs-DataBinding-DataPickerColumn-module__columnErrorMessage-DQ140G"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"columnError\":\"src-wab-client-components-sidebar-tabs-DataBinding-DataPickerColumn-module__columnError-RNmK1M\",\"columnErrorTitle\":\"src-wab-client-components-sidebar-tabs-DataBinding-DataPickerColumn-module__columnErrorTitle-j3NV8Y\",\"columnErrorMessage\":\"src-wab-client-components-sidebar-tabs-DataBinding-DataPickerColumn-module__columnErrorMessage-DQ140G\"}";
        // 1793541991323
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  